import debug from 'debug';
import CloudApi from './CloudApi'

const log = debug('CloudApi:Catalogs');

/**
 * @deprecated use api-management instead, and create missing functionality
 */
class Catalogs extends CloudApi {
	/**
	 * @param {string} query 
	 * 
	 * @returns {Promise}
	 */
	CatalogsByQuery(query) {
		let url = `//${this.settings.cloudApiUrl}/Catalogs/byquery?${ query }`;
		return this.Get(url);
	}

	/**
	 * @param {string} catalogIds 
	 * 
	 * @returns {Promise}
	 */
	CatalogsById(catalogIds, catalogPages) {
		let url = `//${this.settings.cloudApiUrl}/Catalogs/byid?catalogIds=${ catalogIds }`;
		if (catalogPages !== undefined && catalogPages !== '') {
			url = url + `&pages=${ catalogPages }`;
		}
		return this.Get(url);
	}

	/**
	 * @param {string} id 
	 * 
	 * @returns {Promise}
	 */
	CatalogsForCustomer(id) {
		let url = `//${this.settings.cloudApiUrl}/Catalogs/forcustomer/${ id }`;
		return this.Get(url);
	}

	/**
	 * @param {string} id 
	 * 
	 * @returns {Promise}
	 */
	CatalogsForLastPage(id) {
		let url = `//${this.settings.cloudApiUrl}/Catalogs/${ id }/forlastpage`;
		return this.Get(url);
	}

	/**
	 * @param {string} id customer id
	 * 
	 * @returns {Promise} All non-feed catalogs + feed group titles
	 */
	async catalogsOverview(id) {
		const cackeKey = 'catalogsOverview';
		const url = `//${this.settings.cloudApiUrl}/Catalogs/forcustomer/${ id }/overview`;

		try {
			const cache = await this.getCache(cackeKey);
			if (cache !== null) {
				log('catalogsOverview() - dataset from cache', cache);
				return cache
			};

			const response = await this.Get(url);
			if (response.status !== 200) {
				CloudApi.cache[cackeKey] = response.status;
				throw response.status
			}

			const dataset = await response.json();
			log('catalogsOverview() - dataset from endpoint', dataset);
			CloudApi.cache[cackeKey] = dataset;
			return dataset;
		} catch (error) {
			log('catalogsOverview() - EROR', error)
			return error;
		}
	}

	/**
	 * @param {string} tags 
	 * 
	 * @returns {Promise}
	 */
	CatalogsTagged(tags) {
		let url = `//${this.settings.cloudApiUrl}/Catalogs?tags=${ tags }`;
		return this.Get(url);
	}
}

export default Catalogs;
